import api from "app/api";
import { Options } from "common";

export interface ProgramItem {
  id: number;
  name: string;
  display_name: string;
  color: string;
  code: string;
  sku: string;
  review_template: string;
  duration: number;
  partner_booking_close_minutes?: number;
  has_options: boolean;
  sort_by: number;
  always_visible: boolean;
  armband: boolean;
  active: boolean;
  discontinued_at?: string | null;
  partner_visible: boolean;
  ready_tracking: boolean;
  kid_ticket_available: boolean;
  self_seating: boolean;
  seating_layout_ids: number[];
  kitchen?: boolean;
  scheduled?: boolean;
}

export function isProgramAvailable(program: ProgramItem, date = new Date()) {
  const today = [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, "0"),
    String(date.getDate()).padStart(2, "0"),
  ].join("-");
  return (
    program.active &&
    (!program.discontinued_at || program.discontinued_at.slice(0, 10) > today)
  );
}

export function availablePrograms<T extends ProgramItem>(
  programs: T[] = [],
  selectedIds: Array<number | undefined> | null = [],
) {
  const selectedProgramIds = selectedIds ?? [];
  return programs.filter(
    program =>
      isProgramAvailable(program) || selectedProgramIds.includes(program.id),
  );
}

export type ProgramOptions = Options<"role" | "status">;

export function getProgramService(scope?: any) {
  return api.getService<ProgramItem, ProgramItem, ProgramOptions>("programs", {
    scope,
    //params goes here
  });
}

export function copyProgram(id: number) {
  return api.post(`/programs/${id}/copy`);
}
